import {
  GET_PROFILE_DATA_SAGA,
  SET_PROFILE_DATA,
  SET_EXPIRATION_DATA,
  EDIT_PROFLIE_DATA_SAGA,
  END_LOADING,
} from "../actionTypes";

const INITIAL_STATE = {
  profileData: null,
  expirationData: null,
  loading: false,
};

const userProfileReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_EXPIRATION_DATA:
      return {
        ...state,
        expirationData: payload,
      };
    case SET_PROFILE_DATA:
      return {
        ...state,
        profileData: payload,
      };
    case GET_PROFILE_DATA_SAGA:
      return {
        ...state,
        loading: true,
      };
    case EDIT_PROFLIE_DATA_SAGA:
      return {
        ...state,
        loading: true,
      };
    case END_LOADING:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
export default userProfileReducer;
